import { useIntl } from 'react-intl';
import { rooms } from '../../i18n/messages';
import { AssistIcon } from '../../shell/icons';
import { Tooltip } from '../Tooltip';
import { useAssistShell } from './AssistProvider';

/** ⌘ on Apple platforms, Ctrl elsewhere — the tooltip's hint only; the listener accepts both. */
export const shortcutLabel = (): string => (typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform) ? '⌘J' : 'Ctrl+J');

/**
 * The top bar's AI Assist button (planning-app.md §3.6 *AI Assist* → *The panel*, v3.15a): on every
 * route inside the shell, none outside it. A toggle (`aria-expanded`), the panel its target when open.
 * Its name is *AI Assist*; the DS tooltip describes it with the shortcut (*AI Assist · ⌘J*), on hover
 * and on focus, so the shortcut is somewhere (the critique's `_shell` finding 4).
 */
export function AssistButton() {
  const intl = useIntl();
  const assist = useAssistShell();
  return (
    <Tooltip text={intl.formatMessage(rooms.aiAssistTitle, { shortcut: shortcutLabel() })} align="end" testId="assist-tooltip">
      <button
        ref={assist.openerRef}
        type="button"
        className={`tb-btn tb-assist${assist.open ? ' on' : ''}`}
        onClick={assist.toggle}
        aria-label={intl.formatMessage(rooms.aiAssist)}
        aria-expanded={assist.open}
        aria-controls={assist.open ? 'assist-panel' : undefined}
        aria-keyshortcuts="Control+J Meta+J"
        data-testid="assist-button"
      >
        <AssistIcon />
      </button>
    </Tooltip>
  );
}
